export default __webpack_public_path__ + "static/media/PlusIccon.1757757f.svg";